export enum ETourneeDisplayMode {
	day = "jour",
	week = "semaine"
}